module.exports = __webpack_public_path__ + "img/infoTunelera.c5e4eb5e.jpg";